<script>
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import AuthStore from "../Stores/AuthStore"
  import notify from "../../../../Script/notify"
  import OtpInput from "./otpInput.svelte"
  import { push } from "svelte-spa-router"
  /**
   * @type {passwodeNotify}
   */
  let notification = {
    close() {},
  }
</script>

<svelte:head>
  <title>2F Authentication</title>
</svelte:head>

<div class="relative min-h-screen w-full bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />

  <div class="px-6">
    <div class="mx-auto h-auto w-full max-w-[920px] select-none pb-40 pt-6">
      <div class="relative mt-6 flex min-h-[470px] flex-col rounded-md bg-white p-6 dark:bg-mdGray md:p-12">
        <div class="space-y-3">
          <h1 class="lineHeight text-3xl font-extrabold dark:text-white mobile:text-5xl">
            Validate 2FA <br />
            Integration
          </h1>
          <p class="w-full text-gray-200 lg:w-3/5">To validate your 2FA integration, enter the code displayed in your authentication app.</p>
        </div>
        <div class="mt-3 w-full">
          <p class="mb-1 text-sm font-medium text-gray-200">6 digit Authenticator PIN</p>
          <OtpInput
            on:click={() => {
              if (!$AuthStore.QRCode) {
                notification.close()
                notification = notify.info("To scan the QR code, please complete the email verification process.")
                // push("/settings/integration/home")
              } else push("/settings/integration/authenticator/scanQR")
            }}
          />
        </div>
      </div>
    </div>
  </div>
  <Footer />
</div>

<style global>
  .lineHeight {
    line-height: 4rem;
  }
</style>
